  import React from "react";
  import { FaCheck } from "react-icons/fa";
  import { useState } from "react";
  import { hasBgRendering } from "@fullcalendar/core/internal";
  import useApi from "../../hooks/useApi";
  import apiClient from "../../api/apiClient";
  import { toast } from "react-toastify";
  import { useEffect } from "react";
  import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";

  export default () => {
    let initialState = {
      
      account_holder_name: "",
      w9_document: "",
      company_name: "",
      address: "",
      routing_number: "",
      city: "",
      bank_account_number: "",
      state: "",
      ssn_or_ein: "",
      zip_code: "",
      same_driver_licence: "",
    };
    const { userId, userType } = useSelector((state) => state.auth);
    const [payement, setPayment] = useState(initialState);
    const [w9_document, setW9_document] = useState("");
    const [file, setfile] = useState();
    const [Loading,setLoading]=useState(false)
    const HandelChangePayment = (key, value) => {
      setPayment({ ...payement, [key]: value });
      if (key === "w9_document") {
        setW9_document(URL.createObjectURL(value));
      }
    };
  
    console.log(payement?.company_name, "payement.company_name")
    useEffect(() => {
      fetch();   
    }, []);
    const fetch = async () => {
      const response = await apiClient.get("/payment/bank-info/");
      if (response.ok) {
        const data = response.data;
     
        setPayment(...data);

      }

      
    };
      const { request, loading, error } = useApi((formdata) =>
      apiClient.patch(`/payment/bank-info/${payement.id}/`, formdata),
     
     
    );
   
   

  
    const handleSubmit = async (e) => {
      
      e.preventDefault();
console.log(payement.w9_document,'kjhkhk')
      // if (!payement.w9_document) {
      //   console.log('Please upload a W9 document');
      //   toast.error("Please upload a W9 document");
      //   return; 
      // }


     
        // setLoading(true);
       
      const formData = new FormData();
      formData.append("account_holder_name", payement.account_holder_name);
      formData.append("address", payement.address);
      formData.append("city", payement.city);
      formData.append("company_name", payement.company_name);
      formData.append("routing_number", payement.routing_number);
      formData.append("ssn_or_ein", payement.ssn_or_ein);
      formData.append("state", payement.state);
      if (payement.w9_document instanceof File) {
        formData.append("w9_document", payement.w9_document);
      }
      // formData.append("w9_document", payement.w9_document);
      formData.append("zip_code", payement.zip_code);
      formData.append("bank_account_number", payement.bank_account_number);
      // formData.append("same_driver_licence", payement.same_driver_licence);
      setLoading(true)
      const result = await request(formData);

      console.log(result,"asdas")
      setLoading(false)
      if(!result.ok) return toast.error("Error");

toast.success("Payment info Update");
// fetch()

    
     
  };
    
    return (
      <div>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="site-content h-100">  
            <div className="p-4">
              <div className="site-content-body">
                <div className="input-fields">
                  <div className="row justify-content-between">
                    <div className="input-field col-md-5 d-flex flex-column mb-1 fs-5">
                      <label
                        className="label blue-clr m-1"
                        htmlFor="account-holder-name"
                      >
                        Account Holder Name
                      </label>
                      <input
                      required
                        type="text"
                        value={payement?.account_holder_name}
                        onChange={(e) =>
                          HandelChangePayment(
                            "account_holder_name",
                            e.target.value
                          )
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="account-holder-name"
                      />
                    </div>
                    <div className="input-field col-md-5 d-flex flex-column  fs-5">
                      <label className="label blue-clr m-1" htmlFor="upload">
                        W9 Document Upload
                      </label>
                      <label
                        className="licence_bg form-control m-1  px-2 py-1 fs-4 file-input text-center"
                        htmlFor="upload"
                      >
                       {!w9_document && !payement?.w9_document? <i className="bi bi-image-fill" />:  <div className="file-uploaded-text " style={{padding:"6px 0px" }}>File uploaded</div>}
                      </label>
                      <input
                      // required
                        hidden
                        onChange={(e) =>
                          HandelChangePayment("w9_document", e.target.files[0])
                        }
                        type="file"
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="upload"
                      />
                      {/* <img
                        className="img-fluid w-25"
                        src={w9_document || payement?.w9_document}
                        alt=""
                      /> */}
                      <div style={{ width: "5rem" }} className="img pb-2 ">
                        <img width="100%" src={file} alt="" className="" />
                      </div>
                    </div>
                  </div>

                  <div className="row gap-1 gap-md-2 justify-content-between">
                    <div className="input-field col-md-5 d-flex flex-column mb-1 fs-5">
                      <label
                        className="label blue-clr m-1"
                        htmlFor="company-name"
                      >
                        Company Name
                      </label>
                      <input
                      required
                        type="text"
                        value={payement?.company_name}
                        onChange={(e) =>
                          HandelChangePayment("company_name", e.target.value)
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="company-name"
                      />
                    </div>
                    <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5 ">
                      <div className="d-flex flex-wrap align-items-center ">
                        <label className="label blue-clr m-1" htmlFor="address">
                          Address
                        </label>
                        {/* <div className="ms-1 ms-xl-5 d-flex align-items-center">
                          <input
                        
                            checked={payement?.same_driver_licence}
                            type="checkbox"
                            id="same-as"
                            className="m-1 w-auto"
                            onChange={(e) =>
                              HandelChangePayment(
                                "same_driver_licence",
                                e.target.checked
                              )
                            }
                          />
                          <label htmlFor="same-as" className="blue-clr fs-6">
                            Same as Driver's License
                          </label>
                        </div> */}
                      </div>
                      <input
                      required
                        type="text"
                        value={payement?.address}
                        onChange={(e) =>
                          HandelChangePayment("address", e.target.value)
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="address"
                      />
                    </div>
                  </div>

                  <div className="row gap-1 gap-md-2 justify-content-between">
                    <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                      <label
                        className="label blue-clr m-1"
                        htmlFor="routing-number"
                      >
                        Routing Number
                      </label>
                      <input
                      required
                        value={payement?.routing_number}
                        onChange={(e) =>
                          HandelChangePayment("routing_number", e.target.value)
                        }
                        type="number"
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="routing-number"
                      />
                    </div>
                    <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                      <label className="label blue-clr m-1" htmlFor="city">
                        City
                      </label>
                      <input
                        type="text"
                        value={payement?.city}
                        onChange={(e) =>
                          HandelChangePayment("city", e.target.value)
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="city"
                      />
                    </div>
                  </div>

                  <div className="row gap-1 gap-md-2 justify-content-between">
                    <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                      <label
                        className="label blue-clr m-1"
                        htmlFor="bank-account"
                      >
                        Bank Account Number
                      </label>
                      <input
                        type="number"
                        value={payement?.bank_account_number}
                        onChange={(e) =>
                          HandelChangePayment(
                            "bank_account_number",
                            e.target.value
                          )
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="bank-account"
                      />
                    </div>
                    <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                      <label className="label blue-clr m-1" htmlFor="state">
                        State
                      </label>
                      <input
                        type="text"
                        value={payement?.state}
                        onChange={(e) =>
                          HandelChangePayment("state", e.target.value)
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="state"
                      />
                    </div>
                  </div>

                  <div className="row gap-1 gap-md-2 justify-content-between">
                    <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                      <label className="label blue-clr m-1" htmlFor="ssn">
                        SSN or EIN
                      </label>
                      <input
                      required
                        type="text"
                        value={payement?.ssn_or_ein}
                        onChange={(e) =>
                          HandelChangePayment("ssn_or_ein", e.target.value)
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="ssn"
                      />
                    </div>
                    <div className="input-field col-md-5 d-flex flex-column mb-4 fs-5">
                      <label className="label blue-clr m-1" htmlFor="zip">
                        Zip Code
                      </label>
                      <input
                        type="text"
                        value={payement?.zip_code}
                        onChange={(e) =>
                          HandelChangePayment("zip_code", e.target.value)
                        }
                        className="form-control m-1  px-2 py-1 fs-4"
                        id="zip"
                      />
                    </div>
                  </div>
                </div>
                <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                 {!Loading? <button
                    className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0"
                    type="submit"
                  >
                    <span className="pe-2">Save Changes</span>
                    <FaCheck />
                  </button>:    <div className="text-center mt-3">
            <h1>       <CircularProgress /></h1>
          </div>}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  };
